<template>
  <div
    v-if="statsStore.stats?.current_user?.status === 'FALLING_BEHIND'"
    class="w-full bg-orange-50 text-orange-700 text-sm px-4 py-2 border-l-4 border-orange-500 items-center justify-between fade-in"
  >
    <span class="flex font-semibold items-center">
      <CircleAlert class="w-4 h-4 mr-1" />
      You have {{ statsStore.stats?.current_user?.backlog_tasks_count }} backlog tasks.
    </span>
    <span>
      Please complete them to maintain platform access. Continued delays may result in account restrictions.    </span>
  </div>
</template>

<script setup lang="ts">
import { CircleAlert } from 'lucide-vue-next'
import { useStatsStore } from '@/stores/stats'

const statsStore = useStatsStore()


</script> 